import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyDXvp8gtGLQa6_TKMjNcjL-FJtmv-xg4nQ",
  authDomain: "ask-the-class.firebaseapp.com",
  projectId: "ask-the-class",
  storageBucket: "ask-the-class.firebasestorage.app",
  messagingSenderId: "626375774856",
  appId: "1:626375774856:web:22ff7b7a51e8af07e97e5d",
  measurementId: "G-RQ5NM2G9TQ"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export { logEvent };

export const getTimeData = () => {
  const now = new Date();
  return {
    hour: now.getHours(),
    dayOfWeek: now.getDay(),
    date: now.toISOString().split('T')[0]
  };
};

export const getDayName = (dayNum) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[dayNum];
};